import * as React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const Wrapper = styled.div`
  background-color: rgb(238, 133, 69); //#133275;
  @media (max-width: 767px) {
    height: 60px;
  }
  @media (min-width: 768px) {
    height: 100px;
  }

  display: flex;
  justify-content: center;
  align-items: center;

  a {
    text-decoration: none;
  }
  h1 {
    color: white; //#f2c820;
  }
`;

const Header = () => {
  return (
    <Wrapper>
      <Link to={"/"}>
        <h1>둘러보기</h1>
      </Link>
    </Wrapper>
  );
};

export default Header;
